import { ONE_MINUTE_TIMESTAMP } from '@/components/patient-stats/graphs/mapping-chart-options/constants'
import { ONE_SECOND } from '@/utils/time'

export const LIVE_DASH_BOARD_MAX_DATA_LENGTH = 5
export const LIVE_DASH_BOARD_UPDATE_TIMESTAMP = ONE_SECOND * 300
export const LIVE_DASH_STOP_POLLING_TIMESTAMP = ONE_MINUTE_TIMESTAMP * 60
export const enum LIVE_DASHBOARD_TYPES {
  BodyWeights = 'BodyWeights',
  BodyTemperatures = 'BodyTemperatures',
  OxygenSaturations = 'OxygenSaturations',
  PulseRates = 'PulseRates',
  BloodPressureSystolic = 'BloodPressureSystolic',
  BloodPressureDiastolic = 'BloodPressureDiastolic',
}

export const titleByLiveDashboardTypes = {
  [LIVE_DASHBOARD_TYPES.OxygenSaturations]: 'SpO2',
  [LIVE_DASHBOARD_TYPES.PulseRates]: 'Heart Rate',
  [LIVE_DASHBOARD_TYPES.BodyTemperatures]: 'Temperature',
  [LIVE_DASHBOARD_TYPES.BodyWeights]: 'Weight',
  [LIVE_DASHBOARD_TYPES.BloodPressureSystolic]: 'Systolic BP',
  [LIVE_DASHBOARD_TYPES.BloodPressureDiastolic]: 'Diastolic BP',
}

export const unitByLiveDashboardTypes = {
  [LIVE_DASHBOARD_TYPES.OxygenSaturations]: '%',
  [LIVE_DASHBOARD_TYPES.PulseRates]: 'bpm',
  [LIVE_DASHBOARD_TYPES.BodyTemperatures]: '°C',
  [LIVE_DASHBOARD_TYPES.BodyWeights]: 'kg',
  [LIVE_DASHBOARD_TYPES.BloodPressureSystolic]: 'mmHg',
  [LIVE_DASHBOARD_TYPES.BloodPressureDiastolic]: 'mmHg',
}

export const enum LIVE_DASHBOARD_VITAL_SIGN_THRESHOLDS {
  PulseRate = 130, //alert if >=
  OxygenSaturation = 96, //alert if <
  BloodPressureSystolic = 140, //alert if >=
  BloodPressureDiastolic = 90, //alert if >=
  BodyTemperature = 36, //alert if >=
  BodyWeight = 65, //alert if >=
}
